import React from "react";
import DashboardOpportunities from "./DashboardOpportunities";
import DashboardPotentials from "./DashboardPotentials";

export default () => {
  return (
    <div className="d-flex flex-wrap col-12 my-2">
      <DashboardPotentials />
      <DashboardOpportunities />
    </div>
  );
};
